import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/bharat-quest`;

const LS_KEY = "bharat_quest_username_v1";

export function getStoredUsername() {
  return localStorage.getItem(LS_KEY) || "";
}

export function storeUsername(u) {
  localStorage.setItem(LS_KEY, u.toLowerCase());
}

export function clearUsername() {
  localStorage.removeItem(LS_KEY);
}

export const BQ = {
  regions: () => axios.get(`${API}/regions`).then((r) => r.data),
  personalities: () => axios.get(`${API}/personalities`).then((r) => r.data),
  register: (username, display_name) =>
    axios.post(`${API}/register`, { username, display_name }).then((r) => r.data),
  me: (username) => axios.get(`${API}/me`, { params: { username } }).then((r) => r.data),
  daily: (username) => axios.get(`${API}/daily`, { params: { username } }).then((r) => r.data),
  completeQuest: (username, quest_id, answer) =>
    axios.post(`${API}/quest/complete`, { username, quest_id, answer }).then((r) => r.data),
  leaderboard: (limit = 50) =>
    axios.get(`${API}/leaderboard`, { params: { limit } }).then((r) => r.data),
  personalityChat: (username, personality, message, session_id) =>
    axios.post(`${API}/personality/chat`, { username, personality, message, session_id }).then((r) => r.data),
  cardUrl: (username) => `${API}/card/${username}.png`,
};
